import { render } from "./TransactionList.vue?vue&type=template&id=7339fe11"
import script from "./TransactionList.vue?vue&type=script&lang=ts"
export * from "./TransactionList.vue?vue&type=script&lang=ts"
script.render = render

export default script